<template>
  <div class="contact-us-container">
    <div class="contact-us-wrapper">
      <div class="form-section">
        <header class="title-container">
          <!-- <span class="title-decorator"></span> -->
          <h1 class="title">让我们联系您</h1>
          <h2 class="subtitle">
            如果您想获取报价或者了解更多产品详情，请给我们留言。
          </h2>
        </header>

        <el-form ref="form" :model="formInfo" label-width="80px">
          <div class="form-row">
            <div class="form-group half-width">
              <el-form-item label="" label-width="0px">
                <el-select
                  v-model="formInfo.productInterest"
                  popper-class="contact-us-select-proj"
                  :popper-append-to-body="false"
                  placeholder="您想了解哪款产品"
                >
                  <el-option
                    :label="item.name"
                    :value="item.id"
                    v-for="item in productOptions"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="form-group half-width">
              <el-form-item label="" label-width="0px">
                <el-input
                  v-model="formInfo.name"
                  placeholder="如何称呼您"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group half-width">
              <el-form-item label="" label-width="0px">
                <el-input
                  v-model="formInfo.email"
                  placeholder="您的邮箱"
                ></el-input>
              </el-form-item>
            </div>
            <div class="form-group half-width">
              <el-form-item label="" label-width="0px">
                <ContactInfo
                  :areacode.sync="formInfo.ac"
                  :phone.sync="formInfo.phone"
                  language="zh"
                ></ContactInfo>
              </el-form-item>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group half-width">
              <el-form-item label="" label-width="0px">
                <el-input
                  v-model="formInfo.companyInstitutionInfo"
                  placeholder="您的公司或院校名称"
                ></el-input>
              </el-form-item>
            </div>
            <div class="form-group half-width">
              <el-form-item label="" label-width="0px">
                <el-input
                  v-model="formInfo.position"
                  placeholder="您的职务或岗位"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group full-width">
              <el-form-item label="" label-width="0px">
                <el-input
                  type="textarea"
                  rows="4"
                  v-model="formInfo.requirements"
                  placeholder="您可以留下您的需求，我们会制定解决方案并与您联系。"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-row">
            <button
              class="submit-button"
              :class="{ disabled: !isValid }"
              @click="handlerSubmit"
            >
              提交
            </button>
            <button
              class="close-button"
              @click="handerClose"
              v-if="showInModal"
            >
              取消
            </button>
          </div>
        </el-form>
      </div>
      <div class="info-section" v-if="!showInModal">
        <h2>业务咨询</h2>
        <p class="info-sec-item">设计软件：吴经理 17730442539</p>
        <p class="info-sec-item">智能建造：董经理 15280106801</p>
        <p class="info-sec-item">国际业务：张经理 15852479508</p>
      </div>
    </div>
  </div>
</template>

<script>
import ContactInfo from "./ContactInfo.vue";
import { productListApi, saveConsultInfoApi } from "@/api/website";
export default {
  components: { ContactInfo },
  name: "ContractUs",
  props: {
    // 是否弹框中打开
    showInModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      productOptions: [
        // { value: "1", text: "Digital Design Software Product Line" },
        // { value: "2", text: "Intelligent Construction Product Line" },
        // { value: "3", text: "O&M Digital Twin Solutions" },
        // { value: "4", text: "AIRoad" },
        // { value: "5", text: "EICAD" },
        // { value: "6", text: "VRRoad" },
      ],
      formInfo: {
        productInterest: "",
        name: "",
        email: "",
        ac: "+86",
        phone: "",
        requirements: "",
        companyInstitutionInfo: "",
        position: "",
      },
    };
  },
  computed: {
    isValid() {
      return (
        this.formInfo.name &&
        this.formInfo.email &&
        this.formInfo.phone &&
        this.formInfo.productInterest &&
        this.formInfo.companyInstitutionInfo &&
        this.formInfo.position
      );
    },
  },
  mounted() {
    this.getProductList();
  },
  methods: {
    resertForm() {
      this.formInfo = {
        name: "",
        email: "",
        productInterest: "",
        message: "",
        phone: "",
        ac: "+86",
        companyInstitutionInfo: "",
        position: "",
      };
    },

    getProductList() {
      productListApi().then((res) => {
        if (res.code == 200 && res.success) this.productOptions = res.data;
      });
    },
    handlerSubmit(e) {
      e.preventDefault();
      if (this.isValid) {
        // 校验邮箱格式
        const emailPattern = /^[\w.-]+@[\w.-]+\.[a-zA-Z]{2,}$/;
        if (!emailPattern.test(this.formInfo.email)) {
          this.$message.error("请输入正确的邮箱格式");
          return;
        }
        let product = this.productOptions.find(
          (item) => item.id === this.formInfo.productInterest,
        );
        let param = {
          productId: this.formInfo.productInterest, //产品ID
          productName: product ? product.name : "", //产品名称
          customerName: this.formInfo.name, //客户姓名
          ac: this.formInfo.ac, //电话地区号
          phone: this.formInfo.phone, //手机号
          email: this.formInfo.email, //电子邮箱，比如 example@qq.com
          guestbook: this.formInfo.requirements, //留言
          companyInstitutionInfo: this.formInfo.companyInstitutionInfo, //公司或院校名称
          position: this.formInfo.position, //职务或岗位
        };
        saveConsultInfoApi(param).then((res) => {
          if (res.code == 200 && res.success) {
            this.$message.success("提交成功");
            this.resertForm();
            this.showInModal && this.handerClose();
          }
        });
      }
    },
    handerClose() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
.contact-us-container {
  font-family: Arial, sans-serif;
  padding: 64px 0;
  background-color: #fff;
  .contact-us-wrapper {
    position: relative;
    display: flex;
    max-width: 1200px;
    margin: auto;
  }

  .form-section {
    flex: 1;
    max-width: 824px;
  }

  .title-container {
    margin-bottom: 50px;
    padding: 0 20px;
    border-left: 3px solid #0035fb;

    .title {
      height: 32px;
      margin-bottom: 24px;
      font-size: 32px;
      font-weight: bold;
      color: #000;
    }
    .subtitle {
      font-size: 20px;
      line-height: 24px;
      color: #000;
    }

    .title-decorator {
      position: relative;
      left: -70px;
      top: 0px;
      width: 6px;
      height: 120px;
      background-color: #0035fb;
      margin-right: 15px;
    }
  }

  .form-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .form-group {
    display: flex;
    flex-direction: column;
  }

  .half-width {
    width: calc(50% - 10px);
  }

  .full-width {
    width: 100%;
  }

  .el-input .el-input__inner,
  input[type="email"],
  select,
  textarea {
    padding: 20px;
    height: 60px;
    line-height: 60px;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    background-color: #f7f7f7;
    color: #1d1d1f;
    box-sizing: border-box;
    font-family: Arial, Helvetica, sans-serif;
  }
  .el-select {
    width: 100%;
  }
  .el-textarea textarea {
    line-height: 24px;
  }
  .el-form-item {
    margin-bottom: 0;
  }

  input::placeholder,
  textarea::placeholder {
    color: #999;
    font-family: Arial, Helvetica, sans-serif;
  }

  select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20width%3D%27292.4%27%20height%3D%27292.4%27%3E%3Cpath%20fill%3D%27%230035FB%27%20d%3D%27M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%27%2F%3E%3C%2Fsvg%3E");
    background-repeat: no-repeat;
    background-position: right 15px center;
    background-size: 12px;
    color: #1d1d1f;
    &:focus-visible {
      border: none;
      outline: none;
    }
  }

  textarea {
    height: 200px;
    resize: vertical;
    &::placeholder {
      font-family: Arial, Helvetica, sans-serif;
    }
  }

  .submit-button {
    width: 100%;
    max-width: 480px;
    padding: 10px;
    background-color: #0035fb;
    color: white;
    border: none;
    border-radius: 2px;
    font-size: 24px;
    cursor: pointer;
    letter-spacing: 1.5px;
    &.disabled {
      background-color: #ddd;
      cursor: not-allowed;
    }
  }

  .submit-button:hover {
    opacity: 0.8;
  }

  .close-button {
    width: 100%;
    max-width: 320px;
    padding: 10px;
    background-color: #f7f7f7;
    color: #333;
    border: none;
    border-radius: 2px;
    font-size: 24px;
    cursor: pointer;
    letter-spacing: 1.5px;
    &:hover {
      opacity: 0.8;
    }
  }

  // 右侧信息
  .info-section {
    position: absolute;
    top: 124px;
    right: 0;
    width: 260px;
    h2 {
      margin-bottom: 12px;
      max-width: 250px;
      font-size: 16px;
      font-weight: bold;
      color: #000;
      line-height: 24px;
    }

    .info-sec-item {
      margin-bottom: 6px;
      font-size: 16px;
      color: #1d1d1f;
      letter-spacing: 1px;
      line-height: 24px;
      &.strong {
        font-weight: bold;
      }
    }
  }
  .el-select-dropdown {
    .popper__arrow {
      display: none;
    }
    .el-scrollbar__view {
      padding: 0;
    }
    .el-select-dropdown__item {
      height: 48px;
      line-height: 48px;
      font-weight: 400;
      font-size: 16px;
      color: #1d1d1f;
      text-align: justify;
      font-style: normal;
    }
  }
}
</style>
